(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[698],{

/***/ 47415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 52628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseValues = __webpack_require__(47415),
    keys = __webpack_require__(3674);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 83900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowDown = function SvgArrowDown(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        viewBox: "0 0 256 256"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        d: "M0 66.73c0 2.66.981 5.33 2.955 7.41l117.332 123.323a10.64 10.64 0 0 0 7.712 3.314c2.912 0 5.696-1.19 7.712-3.314L253.043 74.14c4.074-4.278 3.914-11.077-.331-15.163a10.627 10.627 0 0 0-15.083.333L128 174.536 18.379 59.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76 10.76 0 0 0 0 66.73"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowDown);


/***/ }),

/***/ 49929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DJ": function() { return /* binding */ titleLineHeights; },
/* harmony export */   "mo": function() { return /* binding */ titleFontSizes; },
/* harmony export */   "t_": function() { return /* binding */ titleFontSizeNumber; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);


var _obj;
var titleFontSizeNumber = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, 0.6875), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, 0.875), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, 1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, 1.125), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, 1.375), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, 1.75), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, 2.25), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, 2.75), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, 3.375), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, 4), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, 4.5), _obj);
var _obj1;
var titleLineHeights = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, "40px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, "48px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, "60px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, "68px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, "72px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, "85px"), _obj1);
var _obj2;
var titleFontSizes = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3], "rem") // 72px
), _obj2);


/***/ }),

/***/ 51261:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
});


/***/ }),

/***/ 91265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ title; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/strings.js
var strings = __webpack_require__(11685);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/react.js
var react = __webpack_require__(12783);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/default-props.js
var default_props = __webpack_require__(51261);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/consts.js
var consts = __webpack_require__(49929);
;// CONCATENATED MODULE: ./segments/desktop/core-components/title/title.scss.js




var StyledTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e168hrcx0"
})(".core-title{font-size:2.25rem;font-weight:400;line-height:48px;word-break:break-word;&.xss{font-size:", consts/* titleFontSizes */.mo[sizes/* XXS */.Mp], ";line-height:32px;font-weight:400;}&.xs_m{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_M */.g4], ";line-height:32px;font-weight:400;}&.xs_ml{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_ML */.l$], ";line-height:32px;font-weight:400;}&.xs_l{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_L */.L4], ";line-height:32px;font-weight:400;}&.xs{font-size:", consts/* titleFontSizes */.mo[sizes.XS], ";line-height:32px;font-weight:400;}&.sm{font-size:", consts/* titleFontSizes */.mo[sizes.SM], ";line-height:40px;font-weight:400;}&.md{font-size:", consts/* titleFontSizes */.mo[sizes.MD], ";line-height:48px;font-weight:400;}&.lg{font-size:", consts/* titleFontSizes */.mo[sizes.LG], ";line-height:60px;font-weight:700;}&.lgr{font-size:", consts/* titleFontSizes */.mo[sizes/* LGR */.Re], ";line-height:68px;font-weight:700;}&.xl{font-size:", consts/* titleFontSizes */.mo[sizes.XL], ";line-height:72px;font-weight:700;}&.xxl{font-size:", consts/* titleFontSizes */.mo[sizes/* XXL */.T3], ";line-height:85px;font-weight:700;}}.title-and-icon-wrapper{display:flex;.icon-wrapper{margin-right:14px;display:flex;align-items:center;.picture-icon-wrapper{display:flex;height:32px;.title-icon{height:100%;}}&.xss{.picture-icon-wrapper{height:8px;}}&.xs_m{.picture-icon-wrapper{height:12px;}}&.xs{.picture-icon-wrapper{height:18px;}}&.sm{.picture-icon-wrapper{height:24px;}}&.md{.picture-icon-wrapper{height:32px;}}&.lg{.picture-icon-wrapper{height:38px;}}&.lgr{.picture-icon-wrapper{height:44px;}}&.xl{.picture-icon-wrapper{height:56px;}}&.xxl{.picture-icon-wrapper{height:62px;}}&.lgr,&.xl,&.xxl{margin-right:20px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.core-title-container .core-title{font-size:2.25rem;line-height:48px;font-weight:400;&.md,&.lg{font-size:1.75rem;line-height:40px;font-weight:700;}&.xl,&.lgr{font-size:2.25rem;line-height:48px;font-weight:700;}&.xxl{font-size:2.75rem;line-height:48px;font-weight:700;}}.title-and-icon-wrapper{.icon-wrapper{.picture-icon-wrapper{height:32px;}&.md,&.lg,&.xl{.picture-icon-wrapper{height:24px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/title/title.js









var Title = function(props) {
    var title = props.title, titleSize = props.titleSize, titleColor = props.titleColor, isFirstSegment = props.isFirstSegment, titleIcon = props.titleIcon, titleClassName = props.titleClassName;
    var getTitleStyle = function() {
        if (!titleColor) {
            return null;
        }
        var titleStyle = {
            color: colors/* default */.Z[titleColor]
        };
        return titleStyle;
    };
    var renderIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("icon-wrapper", titleSize),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                src: titleIcon,
                alt: "",
                className: "title-icon",
                pictureClass: "picture-icon-wrapper"
            })
        });
    };
    var titleAndIconWrapper = function(children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "title-and-icon-wrapper",
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
        className: "core-title-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react/* ConditionalWrapper */.M, {
            condition: !!titleIcon,
            wrapper: titleAndIconWrapper,
            children: [
                titleIcon && renderIcon(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                    tagName: isFirstSegment ? "h1" : "h2",
                    className: classnames_default()("core-title", titleSize, titleClassName),
                    text: (0,strings.encloseBoldTag)(title),
                    style: getTitleStyle()
                })
            ]
        })
    });
};
Title.defaultProps = default_props/* default */.Z;
/* harmony default export */ var title = (Title);


/***/ }),

/***/ 34774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FrequentlyAskedQuestionsPricingComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./static/svg/arrow-down.svg
var arrow_down = __webpack_require__(83900);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/consts.js
var consts = __webpack_require__(49929);
;// CONCATENATED MODULE: ./segments/desktop/core-components/faq-question/faq-question.scss.js




var StyledFaqQuestion = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "exsgj940"
})("width:100%;padding:25px 0;&:active,&:hover{outline:none;}.faq-question-item{margin-top:8px;display:flex;margin-left:16px;justify-content:space-between;}.faq-question-text{font-size:1.125rem;padding-right:8px;margin:unset;&.xss{font-size:", consts/* titleFontSizes */.mo[sizes/* XXS */.Mp], ";line-height:32px;font-weight:400;}&.xs_m{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_M */.g4], ";line-height:32px;font-weight:400;}&.xs_l{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_L */.L4], ";line-height:32px;font-weight:400;}&.xs{font-size:", consts/* titleFontSizes */.mo[sizes.XS], ";line-height:32px;font-weight:400;}&.sm{font-size:", consts/* titleFontSizes */.mo[sizes.SM], ";line-height:40px;font-weight:400;}&.md{font-size:", consts/* titleFontSizes */.mo[sizes.MD], ";line-height:48px;font-weight:400;}&.lg{font-size:", consts/* titleFontSizes */.mo[sizes.LG], ";line-height:60px;font-weight:700;}&.lgr{font-size:", consts/* titleFontSizes */.mo[sizes/* LGR */.Re], ";line-height:68px;font-weight:700;}&.xl{font-size:", consts/* titleFontSizes */.mo[sizes.XL], ";line-height:72px;font-weight:700;}&.xxl{font-size:", consts/* titleFontSizes */.mo[sizes/* XXL */.T3], ";line-height:85px;font-weight:700;}}.down-arrow-wrapper{margin-right:16px;transition:transform 0.3s ease-in-out;padding-top:5px;.down-arrow{width:16px;height:16px;}.down-arrow.white{path{fill:white;}}svg{transition:all 0.3s ease-in-out;}&.open{svg{transform:rotate(180deg);}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.faq-question-text{font-size:0.875rem;font-weight:500;}.faq-answer-item{font-size:0.875rem;&.open{margin-top:20px;margin-bottom:10px;margin-left:20px;margin-right:80px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/faq-question/faq-question.js








var FaqQuestion = function(props) {
    var itemRef = (0,react.useRef)(null);
    var question = props.question, isOpen = props.isOpen, answerId = props.answerId, questionId = props.questionId, index = props.index, translate = props.translate, faqQuestionClickedCallback = props.faqQuestionClickedCallback, questionSize = props.questionSize, theme = props.theme;
    var itemClicked = function() {
        faqQuestionClickedCallback(index);
    };
    var removeFocusOnMouseLeave = function() {
        var _itemRef_current;
        itemRef === null || itemRef === void 0 ? void 0 : (_itemRef_current = itemRef.current) === null || _itemRef_current === void 0 ? void 0 : _itemRef_current.blur();
    };
    var keyDownHandler = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(itemClicked);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFaqQuestion, {
        className: "faq-question",
        onClick: itemClicked,
        onMouseLeave: removeFocusOnMouseLeave,
        "aria-expanded": isOpen,
        role: "button",
        onKeyDown: keyDownHandler,
        tabIndex: 0,
        "aria-controls": answerId,
        ref: itemRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "faq-question-item",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("faq-question-text", questionSize),
                    id: questionId,
                    children: translate(question)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("down-arrow-wrapper", {
                        open: isOpen
                    }),
                    "aria-hidden": true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {
                        className: classnames_default()("down-arrow", {
                            white: (0,segments_service/* isDarkTheme */.$o)(theme)
                        })
                    })
                })
            ]
        }, index)
    });
};
/* harmony default export */ var faq_question = ((0,generic_config_context/* withGenericConfig */.P)(FaqQuestion));

// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./services/pricing/faqs-service.js
var faqs_service = __webpack_require__(38420);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/frequently-asked-questions-pricing/default-props.js



/* harmony default export */ var default_props = ({
    title: "pricingPage.faq",
    titleSize: sizes.LG,
    questionSize: sizes.XS,
    answerSize: sizes.MD,
    questions: faqs_service/* FAQS_FOR_GENERATOR */.jG,
    theme: segments_service/* SNOW_GREY_THEME_ID */.Mx,
    hideQuestionsJumpToShortCut: false
});

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/frequently-asked-questions-pricing/frequently-asked-questions-pricing-component.scss.js





var StyledFrequentlyAskedQuestionsPricingComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e106hnxe0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, ";margin:auto;display:flex;flex-direction:column;justify-content:center;padding:100px 16px;.go-to-faq-with-arrow{bottom:50px;right:", "calc((100vw - ".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, ") / 2 + 40px)"), ";cursor:pointer;position:fixed;display:flex;flex-direction:column;align-items:center;opacity:0;pointer-events:none;transition:opacity 0.2s ease-in;margin-left:32px;&.visible{z-index:", z_index/* LAYER_ONE */.KW, ";opacity:1;pointer-events:initial;}&:hover{.go-to-faq-button{background-color:", colors/* default.white-smoke */.Z["white-smoke"], ";}.down-arrow-wrapper{border-width:0 2px 2px 0;}}@media (max-width:1360px){left:initial;right:40px;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){display:none;}.go-to-faq-button{height:40px;padding:0 16px;border-radius:20px;border:1px solid;border-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";background-color:white;box-shadow:0 0 16px 0 rgba(0,0,0,0.1);display:flex;.text{color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";font-size:0.8125rem;margin:auto;}}.down-arrow-wrapper{box-sizing:border-box;height:12px;width:12px;border-style:solid;border-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";border-width:0 1px 1px 0;transform:rotate(45deg);}}.faq-list{width:800px;max-width:100%;padding:0;margin:0 auto;box-sizing:border-box;}.faq-list-item{list-style:none;border-bottom:1px solid #dedede;cursor:pointer;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;}.faq-answer-item{font-size:0.8125rem;opacity:0;display:none;line-height:1.6;&.dark-theme{a{color:#aed4fc;}}&.md{font-size:1.125rem;line-height:32px;}&.lg{font-size:1.375rem;line-height:40px;}&.open{display:block;margin:40px;opacity:1;}}.frequently-asked-questions-title{text-align:center;margin-bottom:16px;}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/frequently-asked-questions-pricing/frequently-asked-questions-pricing-component.js






function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}














var NO_QUESTION_OPEN_INDEX = -1;
var FrequentlyAskedQuestionsPricingComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FrequentlyAskedQuestionsPricingComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FrequentlyAskedQuestionsPricingComponent);
    function FrequentlyAskedQuestionsPricingComponent(props) {
        (0,_class_call_check/* default */.Z)(this, FrequentlyAskedQuestionsPricingComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "questionClicked", function(faqs, index) {
            var _faqs_index, _faqs_index1;
            var openedQuestionIndex = _this.state.openedQuestionIndex;
            var closingQuestion = openedQuestionIndex === index;
            if (closingQuestion) {
                //close question
                _this.setState({
                    openedQuestionIndex: NO_QUESTION_OPEN_INDEX
                });
            } else {
                //open question
                _this.setState({
                    openedQuestionIndex: index
                });
            }
            (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).FAQ_ACCORDION, {
                click_text: (_faqs_index = faqs[index]) === null || _faqs_index === void 0 ? void 0 : _faqs_index.question,
                isOpen: !closingQuestion
            });
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.FREQUENTLY_ASKED_QUESTION_CLICKED, {
                info2: closingQuestion ? "closed" : "opened",
                info3: faqs[index] && ((_faqs_index1 = faqs[index]) === null || _faqs_index1 === void 0 ? void 0 : _faqs_index1.question)
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getQuestionID", function(question) {
            return "faq_question_".concat(question);
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getAnswerID", function(question) {
            return "faq_answer_".concat(question);
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "scrollToFaq", function() {
            var clusterId = _this.props.clusterId;
            if (_this._faqSection) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_FAQ_QUESTIONS_BUTTON_CLICK, {
                    info1: clusterId
                });
                (0,dom_utils_service.scrollTo)(_this._faqSection.offsetTop - 200, 600);
            }
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderQuestions", function() {
            var _props = _this.props, questions = _props.questions, translate = _props.translate, questionSize = _props.questionSize, answerSize = _props.answerSize, theme = _props.theme;
            var openedQuestionIndex = _this.state.openedQuestionIndex;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "faq-list",
                ref: function(el) {
                    return _this._faqSection = el;
                },
                children: questions.map(function(questionObject, index) {
                    var question = questionObject.question, answer = questionObject.answer;
                    var isOpen = openedQuestionIndex === index;
                    var questionId = _this.getQuestionID(question);
                    var answerId = _this.getAnswerID(question);
                    var displayedAnswer = translate(answer);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "faq-list-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_question, {
                                question: question,
                                answer: answer,
                                index: index,
                                isOpen: isOpen,
                                answerId: answerId,
                                questionId: questionId,
                                faqQuestionClickedCallback: function(index) {
                                    return _this.questionClicked(questions, index);
                                },
                                questionSize: questionSize,
                                theme: theme
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("faq-answer-item", answerSize, {
                                    open: isOpen,
                                    "dark-theme": (0,segments_service/* isDarkTheme */.$o)(theme)
                                }),
                                id: answerId,
                                role: "region",
                                "aria-labelledby": questionId,
                                tabIndex: 0,
                                dangerouslySetInnerHTML: {
                                    __html: displayedAnswer
                                }
                            })
                        ]
                    }, index);
                })
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "onVisibilityChange", function(visible, data) {
            var clusterId = _this.props.clusterId;
            var showGoToFaq = _this.state.showGoToFaq;
            if (visible) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_FAQ_SECTION_VISIBLE, {
                    info1: clusterId
                });
            }
            // showing goto button only if faq seciton is not visible and is below us
            var newShowGoToFaq = !visible && data.top;
            if (showGoToFaq != newShowGoToFaq) {
                _this.setState({
                    showGoToFaq: newShowGoToFaq
                });
            }
        });
        _this._faqSection = null;
        _this.state = {
            openedQuestionIndex: NO_QUESTION_OPEN_INDEX,
            showGoToFaq: true
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(FrequentlyAskedQuestionsPricingComponent, [
        {
            key: "renderGoToFaqButton",
            value: function renderGoToFaqButton() {
                var _props = this.props, translate = _props.translate, hideQuestionsJumpToShortCut = _props.hideQuestionsJumpToShortCut;
                var showGoToFaq = this.state.showGoToFaq;
                var _obj;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (_obj = {
                    role: "button",
                    tabIndex: "0",
                    className: classnames_default()("go-to-faq-with-arrow", {
                        visible: !hideQuestionsJumpToShortCut && showGoToFaq
                    }),
                    onClick: this.scrollToFaq
                }, (0,_define_property/* default */.Z)(_obj, "tabIndex", -1), (0,_define_property/* default */.Z)(_obj, "children", [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "go-to-faq-button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text",
                            children: translate("pricingPage.faq.questions")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "down-arrow-wrapper"
                    })
                ]), _obj));
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, questions = _props.questions, title = _props.title, translate = _props.translate, titleSize = _props.titleSize, titleColor = _props.titleColor;
                var titleProps = {
                    title: translate(title),
                    titleSize: titleSize,
                    titleColor: titleColor
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFrequentlyAskedQuestionsPricingComponent, {
                    className: "frequently-asked-questions-pricing-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "frequently-asked-questions-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, _object_spread({}, titleProps))
                        }),
                        this.renderGoToFaqButton(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                            minTopValue: 200,
                            partialVisibility: true,
                            onChange: this.onVisibilityChange,
                            active: true,
                            scrollCheck: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "faqs-container",
                                children: questions && this.renderQuestions()
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return FrequentlyAskedQuestionsPricingComponent;
}(react.PureComponent);

FrequentlyAskedQuestionsPricingComponent.defaultProps = default_props;


/***/ }),

/***/ 38420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ty": function() { return /* binding */ FAQS; },
/* harmony export */   "h": function() { return /* binding */ FAQS_FOR_PRODUCTS; },
/* harmony export */   "jG": function() { return /* binding */ FAQS_FOR_GENERATOR; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);

var BASE_FAQS_NO_PRODUCTS = [
    {
        question: "pricingPage.faq.new.cost.question",
        answer: "pricingPage.faq.new.cost.answer"
    },
    {
        question: "pricingPage.faq.new.monthly.question",
        answer: "pricingPage.faq.new.monthly.answer"
    },
    {
        question: "pricingPage.faq.new.rightPlanForMe.question",
        answer: "pricingPage.faq.new.rightPlanForMe.answer"
    },
    {
        question: "pricingPage.faq.new.howDoesOurPricingWork.question",
        answer: "pricingPage.faq.new.howDoesOurPricingWork.answer"
    }
];
var BASE_FAQS = [
    {
        question: "pricingPage.faq.new.changedMyMind.question",
        answer: "pricingPage.faq.new.changedMyMind.answer"
    },
    {
        question: "pricingPage.faq.new.discount.question",
        answer: "pricingPage.faq.new.discount.answer"
    },
    {
        question: "pricingPage.faq.new.nonProfits.question",
        answer: "pricingPage.faq.new.nonProfits.answer"
    },
    {
        question: "pricingPage.faq.new.manageBilling.question",
        answer: "pricingPage.faq.new.manageBilling.answer"
    },
    {
        question: "pricingPage.faq.new.changePlan.question",
        answer: "pricingPage.faq.new.changePlan.answer"
    },
    {
        question: "pricingPage.faq.new.security.question",
        answer: "pricingPage.faq.new.security.answer"
    },
    {
        question: "pricingPage.faq.new.paymentMethods.question",
        answer: "pricingPage.faq.new.paymentMethods.answer"
    },
    {
        question: "pricingPage.faq.new.mobile.question",
        answer: "pricingPage.faq.new.mobile.answer"
    }
];
var FAQS = [
    function(param) {
        var hasFreeTier = param.hasFreeTier, hasStudentPlan = param.hasStudentPlan;
        var question = "pricingPage.faq.new.freeVersion.question";
        if (hasStudentPlan) {
            return null;
        }
        if (hasFreeTier) {
            return {
                question: question,
                answer: "pricingPage.faq.new.freeVersion.answer.for_free_tier"
            };
        }
        return {
            question: question,
            answer: "pricingPage.faq.new.freeVersion.answer"
        };
    }
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BASE_FAQS_NO_PRODUCTS), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BASE_FAQS));
var FAQS_FOR_GENERATOR = [
    {
        question: "pricingPage.faq.new.freeVersion.question",
        answer: "pricingPage.faq.new.freeVersion.answer"
    }
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BASE_FAQS_NO_PRODUCTS), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BASE_FAQS));
var FAQS_FOR_PRODUCTS = [
    {
        question: "pricingPage.faq.new.rightPlanForMe.question",
        answer: "pricingPage.faq.products.rightPlanForMe.answer"
    },
    {
        question: "pricingPage.faq.products.whatIsWorkMgmt.question",
        answer: "pricingPage.faq.products.whatIsWorkMgmt.answer"
    },
    {
        question: "pricingPage.faq.products.whatUseProductsFor.question",
        answer: "pricingPage.faq.products.whatUseProductsFor.answer"
    },
    {
        question: "pricingPage.faq.products.howProductsWorkTogether.question",
        answer: "pricingPage.faq.products.howProductsWorkTogether.answer"
    },
    {
        question: "pricingPage.faq.products.diffBetweenWorkMgmtAndProducts.question",
        answer: "pricingPage.faq.products.diffBetweenWorkMgmtAndProducts.answer"
    },
    {
        question: "pricingPage.faq.new.howDoesOurPricingWork.question",
        answer: "pricingPage.faq.products.howPricingWork.answer"
    }
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BASE_FAQS));


/***/ }),

/***/ 11685:
/***/ (function(module) {

"use strict";

var getCapitilizedString = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
/**
 * returns the given string, surrounded by quotes
 * @param {*} str
 */ var addQuotesIfMissing = function(str) {
    if (!str) {
        return str;
    }
    if (!str.startsWith('"')) {
        str = '"' + str;
    }
    if (!str.endsWith('"')) {
        str += '"';
    }
    return str;
};
var toCamelCase = function(str) {
    if (!str) {
        return "";
    }
    var result = str // Lower cases the string
    .toLowerCase() // Replaces any - or _ characters with a space
    .replace(/[-_]+/g, " ") // Removes any non alphanumeric characters
    .replace(/[^\w\s]/g, "") // Uppercases the first character in each group immediately following a space
    // (delimited by spaces)
    .replace(/ (.)/g, function($1) {
        return $1.toUpperCase();
    });
    // upper case first letter
    return result.substring(0, 1).toUpperCase() + result.substring(1);
};
var toKebabCase = function(str) {
    var _str_match_map, _str_match;
    return str === null || str === void 0 ? void 0 : (_str_match = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _str_match === void 0 ? void 0 : (_str_match_map = _str_match.map(function(x) {
        return x.toLowerCase();
    })) === null || _str_match_map === void 0 ? void 0 : _str_match_map.join("-");
};
// Returns the words count in the given text
var getWordsCount = function(text) {
    if (!text || !text.match) {
        return 0;
    }
    return text.match(/\S+/g).length;
};
// THIS IS TEMPORARY FIX FOR TEMPLATES GENERATOR
// Because historically a lot of pages contain bold tags
// With no closing tag in the end, causing the page to break
var encloseBoldTag = function(str) {
    if (!str || !str.match) {
        return str;
    }
    var openningBoldsCount = (str.replace(/ /g, "").match(/<b>/g) || []).length;
    var closingBoldsCount = (str.replace(/ /g, "").match(/<\/b>/g) || []).length;
    return openningBoldsCount > closingBoldsCount ? "".concat(str, "</b>") : str;
};
module.exports = {
    getCapitilizedString: getCapitilizedString,
    addQuotesIfMissing: addQuotesIfMissing,
    toCamelCase: toCamelCase,
    toKebabCase: toKebabCase,
    getWordsCount: getWordsCount,
    encloseBoldTag: encloseBoldTag
};


/***/ })

}]);